import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PortalLayoutComponent } from './layouts/portal-layout/portal-layout.component';
import { AuthGuard } from './core/guards/auth.guard';
import { roleGuard } from './core/guards/role.guard';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () =>
      import('./pages/login/login.module').then(m => m.LoginModule)
  },

  {
    path: '',
    component: PortalLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'solicitud-listado',
        loadChildren: () =>
          import('./pages/solicitud-listado/solicitud-listado.module').then(m => m.SolicitudListadoModule),
        canActivate: [roleGuard],
        data: { roles: [0, 1] }
      },
      {
        path: 'solicitud-nueva',
        loadChildren: () =>
          import('./pages/solicitud-nueva/solicitud-nueva.module').then(m => m.SolicitudNuevaModule),
        canActivate: [roleGuard],
        data: { roles: [0, 1] }
      },
      {
        path: 'clientes',
        loadChildren: () =>
          import('./pages/clientes/clientes.module').then(m => m.ClientesModule),
        canActivate: [roleGuard],
        data: { roles: [1] }
      },
      { path: '', redirectTo: 'solicitud-listado', pathMatch: 'full' }
    ]
  },

  { path: '**', redirectTo: 'login' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
